import type { AddressResponse } from '@/core/generated/api';

export interface AddressOption {
    addressId: string;
    title: string;
    location: string;
    isFavorite: boolean;
}

/** Склеивает непустые части адреса без лишних разделителей. */
const joinAddress = (parts: Array<string | null | undefined>): string => (
    parts.map((part) => part?.trim()).filter(Boolean).join(', ')
);

/** Формирует краткую и подробную строки адреса для выбора. */
export const toAddressOption = (
    address: AddressResponse | null | undefined,
    addressId: string | null | undefined,
    isFavorite: boolean | null | undefined,
): AddressOption | null => {
    if (!address || !addressId) return null;

    const title = joinAddress([
        address.street,
        address.houseNumber
            ? `д. ${address.houseNumber}`
            : null,
        address.apartmentNumber
            ? `кв. ${address.apartmentNumber}`
            : null,
    ]);

    const location = joinAddress([address.cityName, address.cityDistrictName, address.regionName]);

    return {
        addressId,
        title: title || location || 'Адрес без названия',
        location: title
            ? location
            : '',
        isFavorite: Boolean(isFavorite),
    };
};
